"use client";

import dynamic from "next/dynamic";
import LazyLoaded from "@/components/LazyLoaded";
import React from "react";
import { usePromptProgressLeft } from "@/hooks/prompting/usePromptProgressLeft";

const KnowtAIFreeCountPopup = dynamic(() => import("@/features/AiPopup/components/KnowtAIFreeCountPopup"));

const SetEditingPopups = () => {
    const { isOpen: isPromptProgressLeftOpen, closePopup: closeProgressLeftPopup } = usePromptProgressLeft();

    return (
        <>
            <LazyLoaded load={isPromptProgressLeftOpen}>
                <KnowtAIFreeCountPopup isOpen={isPromptProgressLeftOpen} onClose={closeProgressLeftPopup} />
            </LazyLoaded>
            {/* ...REST OF POPUPS IF ANY */}
        </>
    );
};

export default SetEditingPopups;
